import React from "react";
import "./index.style.css";

const About = () => {
  return (
    <section id="about" className="about">
      <div className="main">
        <img
            src="https://firebasestorage.googleapis.com/v0/b/esthetiquebasilix-7e531.appspot.com/o/asxassasa.jpg?alt=media&token=0b4a6e4f-8e6b-4997-8c15-451bb26a3275"
            alt="Soins esthétiques du visage et du corps au Centre Esthétique Basilix à Bruxelles"
            loading="lazy"
            decoding="async"
        />
        <div className="all-text">
          <h2>Bienvenue chez Esthétique Basilix !</h2>
          <p>
            Dans notre centre d'esthétique, nous combinons la technologie de
            pointe avec des années d'expérience et de passion dédiées aux soins
            de la peau. À chaque visite, nos experts en esthétique et bien-être
            sont prêts à personnaliser un plan de traitement adapté à vos
            besoins et objectifs spécifiques. Axés sur la qualité, le confort et
            l'excellence du service, nous nous engageons à répondre à vos
            attentes à chaque fois que vous nous rendez visite.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
